.actions {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

/* A favourite is a filled star (the mockup's `.star[aria-pressed="true"] svg`). */
.star button[aria-pressed="true"] svg {
  fill: currentColor;
  color: var(--text);
}
